import angular from 'angular';
import paymentBillsComponent from './payment-bills.component';
import paymentBillsService from './payment-bills.service';
import paymentBillsConfig from './payment-bills.config';

let paymentBillsModule = angular.module('app.paymentBills',[])
  .component('paymentBills', paymentBillsComponent)
  .service('PaymentBillsService', paymentBillsService)
  .config(paymentBillsConfig);

export default paymentBillsModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/payment-bills/payment-bills.js
 **/